import * as Helper from "./../../_Helper";
const controller = "/patients/mobile/new?";
const controllerAddPatV2 = "/v2/patients/mobile/?";
const controllerPutPatQueue = "/patients/mobile/";

function getUrl(uid, qid, regType) {
  return `${controller}uid=${uid}&qid=${qid}&regtype=${regType}`;
}

function getUrlV2(uid) {
  return `${controllerAddPatV2}uid=${uid}`;
}

function getPutPatientQueueUrl(pid, uid, qid, isSetByDefaultQueue = false) {
  //api/patients/mobile/156548/queue/?uid=555&qid=4&issetbydefaultqueue=false
  return `${controllerPutPatQueue}${pid}/queue/?uid=${uid}&qid=${qid}&issetbydefaultqueue=${isSetByDefaultQueue}`;
}

export function register(http, uid, qid, regType, item) {
  // console.log("register patient ", item, getUrl(uid, qid, regType));
  return http.post(getUrl(uid, qid, regType), item, Helper.getAuthConfig(uid));
}

export function registerV2(http, uid, item) {
  return http.post(getUrlV2(uid), item, Helper.getAuthConfig(uid));
}

export function putPatientQueue(http, pid, uid, qid, isSetByDefaultQueue = false) {
  return http.put(getPutPatientQueueUrl(pid, uid, qid, isSetByDefaultQueue), null, Helper.getAuthConfig(uid));
}

export function x(http, item) {
  //console.log("register x ");
  const config = {
    headers: {
      "content-type": "application/json",
    },
  };
  return http.post("/patients/mobile/x", item, config);
}
